import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';
var DashboardService = /** @class */ (function () {
    function DashboardService(httpClient) {
        this.httpClient = httpClient;
    }
    DashboardService.prototype.getHasUserBackToOldPortal = function () {
        return this.httpClient.get(environment.server.api.typeList + "/api/Settings/oldPortal").pipe(map((mapResponseWithData)));
    };
    DashboardService.prototype.postUserGoesBackToOldPortal = function (message) {
        return this.httpClient.post(environment.server.api.typeList + "/api/Settings/oldPortal", { message: message }).pipe(map(mapResponseWithData));
    };
    return DashboardService;
}());
export { DashboardService };
